import Login from './Login';
import authRoles from 'core/auth/authRole';

const LoginConfig = {
    route: {
        path: '/login',
        element: <Login />,
    },
    layout: {
        header: {
            display: false,
        },
        sidebar: {
            display: false,
        },
        footer: {
            display: false,
        },
    },
    auth: authRoles.onlyGuest
}

export default LoginConfig